<template>
  <div class="paper-card" :style="themeCard">
    <div class="paper-card__inner" :class="{ 'paper-card__inner--no-pad': noInnerPad }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paper-card',
  props: {
    // style
    bg: String,
    fg: String,
    noInnerPad: Boolean,
  },
  computed: {
      themeCard () {
          return {
            background: this.bg,
            color: this.fg,
          };
      },
  },
}
</script>

<style lang="scss">
.paper-card {
    background-color: white;
    box-shadow: 3px 3px 0 rgba(27, 21, 21, 0.2);

    padding: 10px;
}
.paper-card__inner {
  padding: 15px;
  border: 5px double rgba(32, 21, 21, 0.4);
}
.paper-card__inner--no-pad {
  padding: 0;
}
</style>
